import * as Styles from './styles'

export const Loader = () => {
  return (
    <Styles.Container data-testid="coaching-plans-loader">
      <Styles.SpinnerContainer />
    </Styles.Container>
  )
}
